/**
 * Sub-navbar for the learning section.
 *
 * Renders an underline-style tab row that lets users switch between
 * Learning Trails, Corrections, and Runbook Gaps without leaving the
 * learning area.  Visually distinct from the rounded-full status-filter
 * pills used inside each page (those use bg-[#253439] / rounded-full;
 * these use a bottom border / font-weight shift).
 *
 * The "Runbook Gaps" tab is hidden for non-admins — that page and its
 * backend are admin-only.
 */
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getStoredRole } from "../../utils/auth";

const SECTION_TABS = [
  { path: "/learning",             label: "Learning Trails" },
  { path: "/learning/corrections", label: "Corrections" },
  { path: "/learning/insights",    label: "Runbook Gaps", adminOnly: true },
];

const LearningTabs = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const role = getStoredRole();
  const isAdmin = role === "admin";

  return (
    <nav
      aria-label="Learning sections"
      className="flex gap-8 border-b border-gray-200 mb-6"
    >
      {SECTION_TABS.map((tab) => {
        if (tab.adminOnly && !isAdmin) return null;
        const active = pathname === tab.path;
        return (
          <button
            key={tab.path}
            type="button"
            onClick={() => {
              if (!active) navigate(tab.path);
            }}
            className={`pb-2.5 text-[13px] font-semibold tracking-wide uppercase transition-colors whitespace-nowrap ${
              active
                ? "border-b-2 border-cyan-500 text-cyan-600"
                : "text-gray-400 hover:text-gray-600"
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </nav>
  );
};

export default LearningTabs;
